export default {
      id: "header_youtube-usage",
      viewBox: "0 0 43 43",
      url: "../dist/images/" + "sprite.svg#header_youtube-usage",
      toString: function () {
        return this.url;
      }
    }